import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';

import { FinHubNavigationService, FinHubTab } from '@hdms/financial-hub/shared';
import { NavigationTabId, TpmNavigationService } from '@hdms/myaccount-tools/shared';
import { AnalyticsEvent, ExtendedTab } from '@hdms/shared/common-types';
import { UserContextService } from '@hdms/shared/data-access';
import { LoginButtonComponent, TranslationModule } from '@hdms/shared/feature';
import { ButtonModule, SvgIconModule } from '@hdms/shared/ui-core';
import { AnalyticsModule } from '@hdms/shared/util-core';

const manageMyToolsTrackingMap = {
  category: 'SiteOperations',
  action: 'ManageMyToolsFlyout',
  loginOrRegister: 'Login or Register',
  [NavigationTabId.GENERAL_TOOLS]: 'My Tools',
  [NavigationTabId.REPAIR]: 'My Repairs',
  [FinHubTab.ORDERS]: 'My Orders'
};

@Component({
  selector: 'shrd-pf-ft-manage-my-tools',
  standalone: true,
  imports: [NgFor, TranslationModule, ButtonModule, SvgIconModule, NgIf, LoginButtonComponent, AnalyticsModule],
  templateUrl: './manage-my-tools.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManageMyToolsComponent {
  @HostBinding('class') private readonly hostClass = 'd-block';

  protected isLoggedIn = inject(UserContextService).isLoggedIn;
  private readonly myToolsLinks = inject(TpmNavigationService).getStaticTabNavigation();
  private readonly myOrdersLink = inject(FinHubNavigationService)
    .getTabNavigation()
    .find(tab => tab.id === FinHubTab.ORDERS);

  protected readonly links: (ExtendedTab & { trackingData: AnalyticsEvent })[] = [
    ...this.myToolsLinks,
    this.myOrdersLink
  ]
    .filter(Boolean)
    .map(link => ({
      ...link,
      trackingData: {
        category: manageMyToolsTrackingMap.category,
        action: manageMyToolsTrackingMap.action,
        label: manageMyToolsTrackingMap[link.id]
      }
    }));
  protected readonly loginClickTrackEvent: AnalyticsEvent = {
    category: manageMyToolsTrackingMap.category,
    action: manageMyToolsTrackingMap.action,
    label: manageMyToolsTrackingMap.loginOrRegister
  };
}
